import { Box, Flex, forwardRef, ListItem, ListItemProps, Text } from '@chakra-ui/react';
import { dataAttr } from '@chakra-ui/utils';

import { AlgoliaFilterItem } from '@/resources/AlgoliaFilterItem';

interface IComboboxProps extends ListItemProps {
  item: AlgoliaFilterItem;
  isHighlighted: boolean;
}

export const FilterComboboxItem = forwardRef<IComboboxProps, 'li'>(({ isHighlighted, item, ...rest }, ref) => {
  const amount = item.amount ? `(${item.amount})` : '';

  return (
    <ListItem
      fontSize="md"
      fontWeight="semibold"
      lineHeight="short"
      transition="background-color 220ms, color 220ms"
      _hover={{
        color: 'violet.400',
        bg: 'gray.50',
      }}
      data-highlighted={dataAttr(isHighlighted)}
      _highlighted={{
        bg: 'gray.100',
      }}
      py={3}
      cursor="pointer"
      {...rest}
      ref={ref}
    >
      <Flex w="100%" justify="space-between">
        <Box>
          <Text>
            {item.label} {amount}
          </Text>
        </Box>
      </Flex>
    </ListItem>
  );
});
